import { render } from "./PageLayout.vue?vue&type=template&id=2cc55187&scoped=true"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"

import "./PageLayout.vue?vue&type=style&index=0&id=2cc55187&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2cc55187"

export default script